import { sameIdentity, validIdentity } from './types';
import type { LastValidatedSelection, ObservationIdentity, RegistryObservation, ResolvedScope, ScopeIntent } from './types';

export function resolveScope(intent: ScopeIntent, registry: RegistryObservation, identity: ObservationIdentity,
  last?: LastValidatedSelection): ResolvedScope {
  if (!validIdentity(identity)) return { kind: 'blocked', reason: 'identity-required' };
  if (intent.kind === 'invalid') return { kind: 'blocked', reason: 'invalid-intent' };
  if (registry.kind === 'denied') return { kind: 'blocked', reason: 'registry-denied' };
  if (registry.kind === 'unavailable') return { kind: 'blocked', reason: 'registry-unavailable' };
  if (registry.kind === 'pending') return { kind: 'pending' };
  if (intent.kind === 'all') return { kind: 'all', readOnly: true };
  const id = intent.kind === 'environment' ? intent.environmentId
    : last && sameIdentity(identity, last.identity) ? last.environmentId : undefined;
  if (!id) return { kind: 'blocked', reason: 'selection-required' };
  const environment = registry.rows.find(row => row.environmentId === id);
  return environment ? { kind: 'environment', environment } : { kind: 'blocked', reason: 'unregistered' };
}

/** Eligibility only. A concrete scope is necessary, never sufficient authorization. */
export function mutationScopeEligibility(scope: ResolvedScope): { eligible: true; environmentId: string; requiresServerAuthorization: true }
  | { eligible: false; reason: string } {
  if (scope.kind !== 'environment') return { eligible: false, reason: scope.kind === 'all' ? 'all-is-read-only' : 'concrete-scope-required' };
  return { eligible: true, environmentId: scope.environment.environmentId, requiresServerAuthorization: true };
}
